import { plannerCategories } from '@/types/PlannerFormSchema';

export const getCategoryItems = (
  isKreativTeam: boolean,
): { name: string; value: string }[] => {
  return Object.values(plannerCategories).filter(
    (item) => isKreativTeam || item.name !== 'Kreativ',
  );
};
